<template>

        <conteudo :ajax="false">

            <div id="equipesinscritas">
                <h1> Equipes Inscritas </h1>


                <ajaxcontent :url="getURL()"></ajaxcontent>
            </div>  
           
                

        </conteudo>

</template>


<script>
    import Conteudo from './conteudo.vue'
    // import marked from 'marked'

    export default {
        data(){
            return{}
        },

        components: {
            'conteudo':Conteudo
        },

        methods:{
            getURL:function(){
                 return 'https://largadaesportiva.com.br/api/Events/13/payedRegistrations'//`${window.API.apiurl}index.php?cID=328&isAjax=1`
            }
    
        }


    }
    
</script>



<style lang="stylus">
    @import "./../css/variaveis"

    #equipesinscritas{

        th,thead{
               word-break: break-all;
               background lighten(#32383e,20%);
               color:white;
               font-size:0.9em;
               border-color:#32383e;
        }

        td,thead{
               word-break: break-all;
               background darken(#32383e,10%);
               color:white;
               font-size:0.8em;
               border-color:#32383e;
        }
    }


</style>